import { QueryClient, useQuery } from '@tanstack/react-query';
import apiInputService from 'services/apiInputService';

const fetchAnalysisByWorkItemID = async (workItemID: string) => {
  const { data } = await apiInputService.get(`/Analyze/workItem/${workItemID}`);

  return data;
};

export const useAnalysisByWorkItemID = (workItemID: string, options?: any) => {
  return useQuery<any[]>(
    ['analysis-sow', workItemID],
    () => fetchAnalysisByWorkItemID(workItemID),
    {
      enabled: Boolean(workItemID),
      ...options,
    }
  );
};

export const prefetchAnalysisByWorkItemID = async (
  workItemID: string,
  queryClient: QueryClient
) => {
  return await queryClient.prefetchQuery(['analysis-sow', workItemID], () =>
    fetchAnalysisByWorkItemID(workItemID)
  );
};
